var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDietitian(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_14222",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H38V38H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_14222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4564 33.9927H3.54365C1.89399 33.9927 0.556641 32.6553 0.556641 31.0057C0.556641 30.4924 0.972636 30.0764 1.48586 30.0764H36.5142C37.0274 30.0764 37.4434 30.4924 37.4434 31.0057C37.4434 32.6553 36.1061 33.9927 34.4564 33.9927Z",
    stroke: "currentcolor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8047 30.0766V30.48C13.8047 31.3386 14.5007 32.0347 15.3593 32.0347H22.6407C23.4993 32.0347 24.1953 31.3386 24.1953 30.48V30.0766",
    stroke: "currentcolor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8405 30.0762L26.6958 27.9377C26.6154 26.7487 25.7529 25.7589 24.5861 25.5164L20.7871 24.727",
    stroke: "currentcolor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.28 24.727L13.481 25.5164C12.3142 25.7588 11.4517 26.7487 11.3713 27.9377L11.2266 30.0762",
    stroke: "currentcolor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2812 23.0689V24.7273C17.2812 25.6959 18.0664 26.481 19.0349 26.481C20.0034 26.481 20.7885 25.6959 20.7885 24.7273V23.1174",
    stroke: "currentcolor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3695 18.4761C23.3695 18.4761 22.5307 18.226 21.896 17.5222C21.5178 17.1029 20.9062 16.9928 20.4145 17.2705C19.1429 17.9888 16.8154 18.9695 14.7754 18.0164V16.7623C14.7754 15.128 16.1002 13.8032 17.7345 13.8032H19.494C19.8845 13.8032 20.2642 13.9311 20.575 14.1675C20.8747 14.3954 21.2387 14.5227 21.615 14.5313C22.5904 14.5537 23.3695 15.3509 23.3695 16.3266V18.4761Z",
    stroke: "currentcolor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7754 18.016V19.4016C14.7754 19.8755 15.1595 20.2597 15.6334 20.2597C15.6528 21.1633 16.0325 22.033 16.7185 22.6236C17.2708 23.0991 18.047 23.6917 19.0724 23.7031C20.0979 23.6917 20.8742 23.0991 21.4264 22.6236C22.1124 22.033 22.4921 21.1633 22.5114 20.2597C22.9854 20.2597 23.3695 19.8755 23.3695 19.4016V18.4756",
    stroke: "currentcolor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1562 30.0762V12.5524",
    stroke: "currentcolor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83984 21.8749V30.0762",
    stroke: "currentcolor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2648 11.4431H6.59769C6.1791 11.4431 5.83984 11.7823 5.83984 12.2009V19.6201",
    stroke: "currentcolor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.543 30.0762V14.7047",
    stroke: "currentcolor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0054 9.16363H5.7777C4.49609 9.16363 3.45703 10.2026 3.45703 11.4843V30.0762",
    stroke: "currentcolor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2109 4.00754H24.853C23.9191 4.00754 23.1621 4.76465 23.1621 5.69854V10.8616C23.1621 11.7955 23.9191 12.5526 24.853 12.5526H25.9717L24.7187 15.0983C24.5411 15.4591 24.9379 15.8319 25.2871 15.6321L30.6664 12.5526H35.2109C36.1448 12.5526 36.9019 11.7955 36.9019 10.8616V5.69854C36.9019 4.76465 36.1448 4.00754 35.2109 4.00754Z",
    stroke: "currentcolor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDietitian);
export default __webpack_public_path__ + "static/media/dietitian.fd030d11d90ef22c7d317f52fd2502c7.svg";
export { ForwardRef as ReactComponent };